const landing = {
    landingFooter: {
      legal: '법적 고지',
      privacyPolicy: '개인정보처리방침',
      termsOfService: '이용약관',
      location: '주소',
      address: '대전광역시 서구 월평중로 30 (트리플타워)',
      email: '이메일',
      phone: '전화번호',
      businessHours: '운영 시간: 오전 9시 ~ 오후 6시 (KST)',
      lunch: '점심 시간: 오전 11시 30분 ~ 오후 1시 (KST)',
      closed: '주말 및 공휴일은 휴무입니다',
      bank: '계좌 정보',
      bankName: '국민은행',
      accountNumber: '748301-01-604539'
    }
  };
  
  export default landing;